/* Madison & Ivy cart drawer extras: upsell carousel (lightweight, no app) */
(function () {
  var cache = {};
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: cur }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function img(src) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }

  function card(p) {
    var vs = p.variants.filter(function (v) { return v.available; });
    if (!vs.length) return '';
    var v = vs[0];
    var opts = '<option value="">Select option</option>' + vs.map(function (x) {
      var vi = x.featured_image && x.featured_image.src ? x.featured_image.src : '';
      return '<option value="' + x.id + '" data-img="' + esc(vi) + '" data-price="' + x.price + '" data-cmp="' + (x.compare_at_price || 0) + '">' + esc(x.title) + '</option>';
    }).join('');
    var cmp = v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '';
    return '<div class="rr-up__card">' +
      '<a href="' + esc(p.url) + '" class="rr-up__img"><img src="' + esc(img(p.featured_image)) + '" alt="' + esc(p.title) + '" loading="lazy" width="90" height="120"></a>' +
      '<div class="rr-up__info"><a href="' + esc(p.url) + '" class="rr-up__title">' + esc(p.title) + '</a>' +
      '<div class="rr-up__price">' + cmp + '<span>' + money(v.price) + '</span></div>' +
      '<div class="rr-up__row">' + (vs.length > 1 || v.title !== 'Default Title' ? '<select class="rr-up__select" aria-label="Choose option">' + opts + '</select>' : '<input type="hidden" class="rr-up__select" value="' + v.id + '">') +
      '<button type="button" class="rr-up__add">Add</button></div></div></div>';
  }

  function render(box, list) {
    var ex = (box.getAttribute('data-exclude') || '').split(',');
    var html = list.filter(function (p) { return ex.indexOf(String(p.id)) === -1; }).slice(0, 2).map(card).join('');
    if (!html) { box.hidden = true; return; }
    box.querySelector('.rr-up__track').innerHTML = html;
    box.hidden = false;
  }

  function fill() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var box = drawer.querySelector('[data-rr-upsell]');
    if (!box || box.getAttribute('data-done') === '1') return;
    box.setAttribute('data-done', '1');
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    if (cache[pid]) return render(box, cache[pid]);
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { cache[pid] = d.products || []; render(box, cache[pid]); })
      .catch(function () { box.hidden = true; });
  }

  // Capture phase: handle the upsell select ourselves and stop the event before
  // Dawn's cart-drawer-items change handler treats it as a quantity input.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('rr-up__select')) return;
    e.stopPropagation();
    sel.classList.remove('is-error');
    var opt = sel.options && sel.options[sel.selectedIndex];
    if (!opt || !opt.value) return;
    var cardEl = sel.closest('.rr-up__card');
    var im = cardEl.querySelector('.rr-up__img img');
    var src = opt.getAttribute('data-img');
    if (im && src) im.src = img(src);
    var pr = cardEl.querySelector('.rr-up__price');
    var p = Number(opt.getAttribute('data-price')), c = Number(opt.getAttribute('data-cmp'));
    if (pr && p) pr.innerHTML = (c > p ? '<s>' + money(c) + '</s> ' : '') + '<span>' + money(p) + '</span>';
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('rr-up__select')) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.rr-up__nav');
    if (nav) {
      var t = nav.closest('[data-rr-upsell]').querySelector('.rr-up__track');
      t.scrollBy({ left: (nav.getAttribute('data-dir') === 'next' ? 1 : -1) * t.clientWidth, behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest('.rr-up__add');
    if (!btn) return;
    var sel = btn.parentNode.querySelector('.rr-up__select');
    if (!sel.value) { sel.classList.add('is-error'); sel.focus(); return; }
    btn.disabled = true; btn.textContent = '...';
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      var drawer = document.querySelector('cart-drawer');
      if (res && res.sections && drawer && drawer.renderContents) { res.id = res.items && res.items[0] ? res.items[0].product_id : null; drawer.renderContents(res); }
      else { window.location.href = '/cart'; }
    }).catch(function () { window.location.href = '/cart'; });
  });

  // Minus at quantity 1 (or typing 0) removes the line instead of Dawn's "minimum of 1" error.
  function rrRemove(input) {
    var b = document.querySelector('#CartDrawer-Remove-' + input.getAttribute('data-index') + ' button');
    if (b) b.click();
  }
  document.addEventListener('click', function (e) {
    var mb = e.target.closest && e.target.closest('#CartDrawer .quantity__button[name="minus"]');
    if (!mb) return;
    var input = mb.parentNode.querySelector('.quantity__input');
    if (input && Number(input.value) <= 1) { e.preventDefault(); e.stopPropagation(); rrRemove(input); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('quantity__input') && t.closest('#CartDrawer') && Number(t.value) === 0) { e.stopPropagation(); rrRemove(t); }
  }, true);

  var timer;
  function watch() {
    var root = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!root) return;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(fill, 50); }).observe(document.querySelector('cart-drawer'), { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    fill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
